import { render, staticRenderFns } from "./ClientKnowledge.vue?vue&type=template&id=49cef1af&scoped=true&"
import script from "./ClientKnowledge.vue?vue&type=script&lang=js&"
export * from "./ClientKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./ClientKnowledge.vue?vue&type=style&index=0&id=49cef1af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cef1af",
  null
  
)

export default component.exports